module.exports = __webpack_public_path__ + "static/banner-revistas-cuadrado-793efbc03cd837fe5f2ce76cc1a75df2.jpg";